import clsx from 'clsx';
import { useEffect, useRef } from 'react';
import { ArrowDownIcon } from '@/components/icons/ArrowDownIcon';
import OptionsDropdown from '@/components/OptionsDropdown';

type DropDownFilterFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label: string }[];
  isOpen: boolean;
  onToggle: () => void;
};

export default function DropDownFilterField({
  label,
  value,
  onChange,
  options,
  isOpen,
  onToggle,
}: DropDownFilterFieldProps) {
  const dropdownRef = useRef<HTMLDivElement>(null);

  const getDisplayLabel = (val: string) => {
    const option = options.find((opt) => opt.value === val);
    return option ? option.label : '';
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!isOpen) return;
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        onToggle();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, onToggle]);

  return (
    <div ref={dropdownRef} className="w-full lg:max-w-[240px] mx-auto lg:mx-0 relative">
      <h4 className="text-sm font-medium text-black font-avenir mb-3">{label}</h4>
      <button
        onClick={onToggle}
        className="w-full lg:max-w-[240px] h-[40px] px-4 bg-[#F4F4F4] rounded-[10px] flex items-center justify-between text-sm font-medium font-avenir text-[#767676] hover:bg-[#EBEBEB] transition-colors"
      >
        <span className={clsx({ 'text-black': value })}>{getDisplayLabel(value)}</span>
        <ArrowDownIcon isOpen={isOpen} />
      </button>
      {isOpen && (
        <OptionsDropdown
          options={options}
          onOptionChange={(newValue) => {
            onChange(newValue);
            onToggle();
          }}
          onClose={onToggle}
        />
      )}
    </div>
  );
}
